'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hexToRGBA;
function hexToRGBA(color, opacity) {
  var rgb = [[1, 3], // red
  [3, 5], // green
  [5, 7]].map(function (positions) {
    return parseInt(color.slice(positions[0], positions[1]), 16);
  });

  return 'rgba(' + rgb.join(',') + ',' + opacity + ')';
}